import { Injectable, OnDestroy } from '@angular/core';
import { IConvertor } from '../../../models/project/project-model';
import {
    IOrganIn,
    IOrganInMetadata,
    IOrganization,
    IOrganizationMetadata,
} from '../../../models/organization/organization-model';
import { MissingArgumentsError } from '../../../models/errors/general.errors';
import { ProfileService } from '../../show/profile.service';

@Injectable()
export class OrganizationConverterService implements IConvertor<IOrganIn, IOrganization, IOrganization>, OnDestroy {
    constructor(private profileService: ProfileService) {}

    inToLocal(input: IOrganIn): IOrganization {
        if (!input) {
            throw new MissingArgumentsError(`Could not convert in organization to local because it's missing!`);
        }
        const localOrgan: IOrganization = {
            id: input.id,
            name: input.name,
            workspaces: input.workspaces,
            createdByEmail: input.createdByEmail,
            isOrganOwner: input.isOrganizationOwner === true,
            isOrganizationOwner: input.isOrganizationOwner === true,
            canViewOrganization: input.canViewOrganization === true,
            canManageOrganization: input.canManageOrganization === true,
            branding: input.branding,
            userCount: input.userCount,
            workspacesMeta: input.workspacesMeta,
            security: input.security,
        };
        return localOrgan;
    }

    localToOut(client: IOrganization): IOrganization {
        return client;
    }

    inMDToLocal(input: IOrganInMetadata) {
        const localMD: IOrganizationMetadata = {
            id: input.id,
            name: input.name,
            workspaces: input.workspaces,
            createdByEmail: input.createdByEmail,
            isOrganOwner: input.isOrganizationOwner === true,
            isOrganizationOwner: input.isOrganizationOwner === true,
            canViewOrganization: input.canViewOrganization === true,
            canManageOrganization: input.canManageOrganization === true,
            branding: input.branding,
            isAllowedToUseOrganization: input.isAllowedToUseOrganization,
            userCount: input.userCount,
            isDefaultForUser: input.isDefaultForUser,
            security: input.security,
        };
        return localMD;
    }

    ngOnDestroy(): void {}
}
